import { Component, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { OrderWindow } from '../../../../models/order-window.model';
import { OrderService } from '../../../../services/order.service';
import { ModalService } from '../../../../services/modal.service';
import { ProductService } from '../../../../services/product.service';

@Component({
  selector: 'app-header-callout',
  templateUrl: './header-callout.component.html',
  styleUrls: ['./header-callout.component.scss'],
  encapsulation: ViewEncapsulation.None,
  standalone: false,
})
export class HeaderCalloutComponent {
  constructor(
    private orderService: OrderService,
    private productService: ProductService,
    private router: Router,
    private modalService: ModalService
  ) {}

  get orderWindow(): OrderWindow {
    // Prefer the window matching the current URL (so we reflect what the
    // user is browsing — including upcoming windows, which don't live in
    // state.activeOrderWindow). Fall back to the active window otherwise.
    const match = this.router.url.match(/\/buying-window\/(\d+)(\b|\/)/);
    if (match) {
      const id = +match[1];
      const w = this.orderService.orderWindows.find((ow) => ow.id === id);
      if (w) {
        return w;
      }
    }
    return this.orderService.activeOrderWindow;
  }

  get statistics(): any {
    return this.productService.statistics;
  }

  get formattedDates(): string {
    if (!this.orderWindow) {
      return '';
    }
    return `${this.orderWindow.start_at.format('MMMM D, YYYY')} - ${this.orderWindow.end_at.format('MMMM D, YYYY')}`;
  }

  selectActiveWindow() {
    if (this.router.url === '/') {
      // for home page - switch order window - otherwise do redirect to buying windows programs
      this.orderService.switchActiveOrderWindow();
    } else {
      const activeBuyingWindow = this.orderService.findLastActiveOrder();
      if (activeBuyingWindow) {
        this.router.navigate([
          '/buying-window',
          activeBuyingWindow.id,
          'programs',
        ]);
      }
    }
  }

  showCalendar() {
    this.modalService.showBuyingWindowsDetailsModal();
  }
}
